import type {ReactNode} from "react";

/**
 * Minimal markdown-lite: paragraphs, `-` bullets, `**bold**`.
 */
export function renderHelpText(body: string) {
  const lines = body.split(/\r?\n/);
  const nodes: ReactNode[] = [];
  let bulletBuffer: string[] = [];

  const flushBullets = () => {
    if (bulletBuffer.length === 0) return;
    nodes.push(
      <ul key={`ul-${nodes.length}`} className="flex list-disc flex-col gap-1 pl-4">
        {bulletBuffer.map((item, index) => (
          <li key={index}>{renderInlineBold(item)}</li>
        ))}
      </ul>,
    );
    bulletBuffer = [];
  };

  lines.forEach((line, index) => {
    const trimmed = line.trim();
    if (!trimmed) {
      flushBullets();
      return;
    }
    if (trimmed.startsWith("- ")) {
      bulletBuffer.push(trimmed.slice(2));
      return;
    }
    flushBullets();
    nodes.push(
      <p key={`p-${index}`} className="text-sm leading-relaxed">
        {renderInlineBold(trimmed)}
      </p>,
    );
  });

  flushBullets();
  return <div className="flex flex-col gap-2">{nodes}</div>;
}

function renderInlineBold(text: string) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return (
        <strong key={index} className="font-medium text-foreground">
          {part.slice(2, -2)}
        </strong>
      );
    }
    return <span key={index}>{part}</span>;
  });
}
